import { createGlobalStyle } from "styled-components";
import { FontSize, FontWeight, dominant, form, transparentize } from "@glossy";
import { GlossyTheme } from "@glossy/theme/types";

const BOUND_WIDTH = 3;
const DOT_WIDTH = 3;
const HANDLE_WIDTH = 16;
const RAIL_WIDTH = 3;
const TRACK_WIDTH = RAIL_WIDTH;

export default createGlobalStyle<{
  theme: GlossyTheme;
}>`
  .rc-slider {
    position: relative;
    height: ${HANDLE_WIDTH}px;
    padding: ${(HANDLE_WIDTH - TRACK_WIDTH) / 2} 0;
    width: 100%;
    box-sizing: border-box;
    * { box-sizing: border-box; }
  }

  .rc-slider-track {
    position: absolute;
    left: 0;
    height: ${TRACK_WIDTH}px;
    background-color: ${(props) => form(props, "include")};
  }

  .rc-slider-handle {
    position: absolute;
    margin-top: -${(HANDLE_WIDTH - TRACK_WIDTH) / 2}px;
    width: ${HANDLE_WIDTH}px;
    height: ${HANDLE_WIDTH}px;
    cursor: pointer;
    border-radius: 50%;
    background-color: ${(props) => form(props, "include")};
    box-shadow: 0 0 0 0 ${(props) =>
      transparentize(0.85, form(props, "include"))};
    transition: box-shadow 0.6s ease;
    &:hover {
      box-shadow: 0 0 0 10px ${(props) =>
        transparentize(0.85, form(props, "include"))};
    }
    &:active {
      box-shadow: 0 0 0 10px ${(props) =>
        transparentize(0.8, form(props, "include"))};
    }
  }

  .rc-slider-handle-active {
    &:active {
      border-color: ${dominant};
    }
  }

  .rc-slider-rail {
    position: absolute;
    width: 100%;
    background-color: ${(props) =>
      transparentize(0.85, form(props, "include"))};
    height: ${RAIL_WIDTH}px;
    &:before,
    &:after {
      content: "";
      position: absolute;
      background-color: ${(props) =>
        transparentize(0.8, form(props, "include"))};
      height: ${BOUND_WIDTH}px;
      width: ${BOUND_WIDTH}px;
      border-radius: ${BOUND_WIDTH / 2}px;
      top: -${(BOUND_WIDTH - RAIL_WIDTH) / 2}px;
    }
    &:before {
      left: -2px;
    }
    &:after {
      right: -2px;
    }
  }

  .rc-slider-mark {
    position: absolute;
    top: 18px;
    left: 0;
    width: 100%;
    font-size: 12px;
  }

  .rc-slider-mark-text {
    position: absolute;
    display: flex;
    align-items: center;
    text-align: center;
    cursor: pointer;
    color: ${form};
    font-size: ${FontSize.Medium};
    pointer-events: none;
  }

  .rc-slider-mark-text-active {
    color: ${(props) => form(props, "include")};
    font-weight: ${FontWeight.Bold};
  }

  .rc-slider-step {
    position: absolute;
    width: 100%;
    height: ${RAIL_WIDTH}px;
    background: transparent;
  }

  .rc-slider-dot {
    position: absolute;
    bottom: -${(DOT_WIDTH - TRACK_WIDTH) / 2}px;
    width: ${DOT_WIDTH}px;
    height: ${DOT_WIDTH}px;
    border: ${DOT_WIDTH / 2}px solid ${(props) =>
  transparentize(0.5, form(props, "include"))};
    cursor: pointer;
    border-radius: 50%;
    vertical-align: middle;
    pointer-events: none;
    &:last-child {
      margin-left: -${DOT_WIDTH / 2}px;
    }
  }

  .rc-slider-dot-active {
    border-color: ${(props) => form(props, "include")};
  }

  .rc-slider-disabled {
    .rc-slider-handle,
    .rc-slider-dot {
      border-color: ${(props) => transparentize(0.8, form(props, "include"))};
      background-color: ${(props) =>
        transparentize(0.8, form(props, "include"))};
      pointer-events: none;
    }
  }

  .rc-slider-hidden {
    display: none;
  }
`;
